const budgItems = [
    'Family',
    'Children',
    'School',
    'Text books',
    'Transportation',
    'Food',
    'Clothing',
    'School fees',
    'Rent',
    'Health', 
    'Furniture',
    'Accessories',
    'Girl friend',
    'Side chick', 
    'Prophet offering',
    'Offering',
    'Charity',
    'Tithe',
    'Tax',
    'Boyfriend',
    'Parents',
    'Community service',
    'Covenant seed',
    'Fuel', 
    'Gas', 
    'Picnic', 
    'Vacation',
    'Travel',
    'Snacks', 
    'Books', 
    'Drinks',
    'Cigarette',
    'Research', 
    'Gadgets', 
    'Underwears',
    'Jewellries',
     'Contribution',
    'Paint', 
     'Maintenance',
     'Therapy', 
    'Tools', 
    'Computers',
    'Beverages',
    'Ante-natal', 
    'Cream', 
    'Refrigerator',
     'Light bills',
    'Waste disposal',
    'Boots',
     'Fans',
     'Music',
     'Others'
 

]

export default budgItems